import type { League } from '@betterpool/api-types';

import type { PublicBoost } from './boost.types';

// eslint-disable-next-line no-restricted-syntax
enum BoostPayoutType {
  FIXED = 'fixed',
  PERCENTAGE = 'percentage',
  TICKET = 'ticket',
}

// eslint-disable-next-line no-restricted-syntax
enum BoostTicketType {
  BOOST = 'boost',
  UNLOCK_BOOST = 'unlock_boost',
}

// eslint-disable-next-line no-restricted-syntax
enum ContestTypeEnum {
  TEAM_BRACKETS = 'team_brackets',
  PLAYER_ONE_AND_DONE = 'player_one_and_done',
  PLAYER_TIER = 'player_tier',
  PLAYER_CATEGORY = 'player_category',
  TEAM_SURVIVOR = 'team_survivor',
  TEAM_PICK_EM = 'team_pick_em',
  PLAYER_SURVIVOR = 'player_survivor',
  UNKNOWN = 'unknown',
}

// eslint-disable-next-line no-restricted-syntax
enum VoucherTypeLocal {
  QUICKPICKS = 'QUICKPICKS',
  CONTEST_ID_RESTRICTED = 'CONTEST_ID_RESTRICTED',
  CONTESTS = 'CONTESTS',
  LEAGUES = 'LEAGUES',
  GENERAL = 'GENERAL',
}

export type VoucherDefinitionResponse = {
  id: string;
  voucherType: VoucherTypeLocal;
  /** Max value in cents */
  maxValue: number;
  expiresAt: Date;
  restrictedContestId?: string;
  league?: League;
  contestType?: ContestTypeEnum;
  contestName?: string;
  createdAt: Date;
  description?: string;
  title?: string;
};

export type BonusDefinitionResponse = {
  id: string;
  name: string;
  title?: string;
  description?: string;
  subtitle?: string;
  typeName?: string;
  trigger?: string;
  kind: string;
  calculationType: string;
  percentage?: number;
  flatAmountCents?: number;
  minDepositCents?: number;
  maxBonusCents?: number;
  playthroughMultiple: number;
  playthroughDeadlineDays?: number;
  startsAt?: string;
  endsAt?: string;
  isActive: boolean;
  perUserRedemptions: number;
  maxOverallRedemptions?: number;
  createdAt: string;
  updatedAt: string;
};

export type PromoCodeResponse = {
  createdAt: string;
  createdBy: string;
  expiresAt: string;
  id: string;
  maxPerUser: number;
  maxRedemptions: number;
  promoCode: string;
  startsAt: string;
  title: string;

  description?: string;
  associatedUser?: string;
  eligibleUsers?: string[];
  creditAmount?: number;
  creditType?: string;
  voucherIds?: string[];
  bonusIds?: string[];
  boostIds?: string[];
  bonuses?: BonusDefinitionResponse[];
  vouchers?: VoucherDefinitionResponse[];
  boosts?: PublicBoost[];
  validationError?: string;
};

export type ClaimPromoCodeResponse = {
  bonusIds?: string[];
  voucherIds?: string[];
  boostIds?: string[];
};

export type ValidatePromoCodeResponse = {
  message?: string;
};
